import React, { Component } from 'react';
import { getApiUrl, createApiAction } from './actions';
import { connect } from 'react-redux';
import Clipboard from 'react-clipboard.js';
import {
    Modal, Button, message
} from 'antd';
import store from '../../../store';
import Urls from '../../../../config';
let api = Urls.TaskUrl.getApi;
let first = true;
window.callback = function(obj) {
    console.log(obj)
    if (obj.success) {
        const {data: {api}} = obj;
        store.dispatch(createApiAction({url: api}));
    }
};
function loadScript(url) {
    let script = document.createElement('script');
    script.src = url;
    document.head.parentNode.insertBefore(script, document.head);
}

class ShowApiUrl extends Component {
    changeStatus = () => {
        this.props.changeStatus({isShowApi: false, taskId: '', url: ''});
        first = true;
    };
    refresh = () => {
        const {apiShow} = this.props;
        const {taskId} = apiShow;
        let getApi = api + '?taskId=' + taskId;
        loadScript(getApi);
    }
    onSuccess = () => {
        message.success('成功');
    }
    render() {
        const {apiShow} = this.props;
        const {isShowApi, url, taskId} = apiShow;
        if (taskId && first) {
            first = false;
            let getApi = api + '?taskId=' + taskId;
            loadScript(getApi);
        }
        return (
            <div>
                <Modal
                    title='apiUrl'
                    visible={isShowApi}
                    onCancel={() => this.changeStatus()}
                    footer={null}
                >
                    <span style={{'wordBreak': 'break-all'}}>{url}</span>
                    <div><Clipboard data-clipboard-text={url} onSuccess={this.onSuccess}>
                        <span style={{'display': 'block', 'width': '40px', 'height': '20px', 'lineHeight': '20px'}}>复制</span>
                    </Clipboard> <Button type="primary" onClick={this.refresh} style={{'marginLeft': '20px'}}>刷新</Button></div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apiShow: state.tasklist.apiShow,
});

const mapDispatchToProps = dispatch => ({
    getApiUrl: param => dispatch(getApiUrl(param)),
    changeStatus: status => dispatch(createApiAction(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowApiUrl);



// WEBPACK FOOTER //
// ./pages/task/tasklist/showApi.js